import React from 'react';
import s from './s.module.less';

const Tips = () => {
    return (
        <div className={s.wrap}>
            <div className={s.des}>
                You’re setting up automated greetings that will be sent after a patient books a visit with you.
                <br />
                <b>This is not the final message</b> — it’s your instruction to the AI on how to generate greetings. Each patient will receive a personalized message based on your instruction.
            </div>
            <div className={s.tips}>
                <div className={s.tipsTitle}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M11 3C11 2.44772 10.5523 2 10 2C9.44771 2 9 2.44772 9 3V4C9 4.55228 9.44771 5 10 5C10.5523 5 11 4.55228 11 4V3Z" fill="#F59E0B" />
                        <path d="M15.6568 5.75731C16.0473 5.36678 16.0473 4.73362 15.6568 4.34309C15.2663 3.95257 14.6331 3.95257 14.2426 4.34309L13.5355 5.0502C13.145 5.44072 13.145 6.07389 13.5355 6.46441C13.926 6.85494 14.5592 6.85494 14.9497 6.46441L15.6568 5.75731Z" fill="#F59E0B" />
                        <path d="M18 10C18 10.5523 17.5523 11 17 11H16C15.4477 11 15 10.5523 15 10C15 9.44771 15.4477 9 16 9H17C17.5523 9 18 9.44771 18 10Z" fill="#F59E0B" />
                        <path d="M5.05019 6.46443C5.44071 6.85496 6.07388 6.85496 6.4644 6.46443C6.85493 6.07391 6.85493 5.44074 6.4644 5.05022L5.7573 4.34311C5.36677 3.95259 4.73361 3.95259 4.34308 4.34311C3.95256 4.73363 3.95256 5.3668 4.34308 5.75732L5.05019 6.46443Z" fill="#F59E0B" />
                        <path d="M5 10C5 10.5523 4.55228 11 4 11H3C2.44772 11 2 10.5523 2 10C2 9.44771 2.44772 9 3 9H4C4.55228 9 5 9.44771 5 10Z" fill="#F59E0B" />
                        <path d="M8 16V15H12V16C12 17.1046 11.1046 18 10 18C8.89543 18 8 17.1046 8 16Z" fill="#F59E0B" />
                        <path d="M12.0009 14C12.0155 13.6597 12.2076 13.3537 12.4768 13.1411C13.4046 12.4086 14 11.2738 14 10C14 7.79086 12.2091 6 10 6C7.79086 6 6 7.79086 6 10C6 11.2738 6.59545 12.4086 7.52319 13.1411C7.79241 13.3537 7.98451 13.6597 7.99911 14H12.0009Z" fill="#F59E0B" />
                    </svg>
                    Tips
                </div>
                <ul>
                    <li>Make your greeting feel personal by adding appointment details like the patient’s name, appointment date & time, and visit reason.</li>
                    <li>
                        Include a meeting link so patients don’t miss your call.
                    </li>
                </ul>
            </div>
            <div className={s.howTitle}>
                How it works
            </div>
            <div className={s.howList}>
                <div className={s.howItem}>
                    <span className={s.icon}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5" fill="none">
                            <circle cx="2.5" cy="2.5" r="2.5" fill="#0E62F4" />
                        </svg>
                    </span>
                    <div className={s.howItemTitle}>
                        Choose how to create your instruction
                    </div>
                    <div className={s.howItemContent}>
                        <ul>
                            <li><b>AI-assisted:</b> Select a tone and let AI draft an instruction for the greeting.</li>
                            <li><b>Write your own:</b> Enter your own instructions for how the greeting should sound.</li>
                        </ul>
                    </div>
                </div>
                <div className={s.howItem}>
                    <span className={s.icon}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5" fill="none">
                            <circle cx="2.5" cy="2.5" r="2.5" fill="#0E62F4" />
                        </svg>
                    </span>
                    <div className={s.howItemTitle}>
                        Personalize your instruction
                    </div>
                    <div className={s.howItemContent}>
                        Add patient details like
                        <span className={s.label}>Patient Name</span>,
                        <span className={s.label}>Appointment Type</span>,
                        <span className={s.label}>Appointment Date</span>,
                        <span className={s.label}>Appointment Time</span>,
                        and <span className={s.label}>Visit Reason</span>,
                        to make each greeting personalized.
                    </div>
                </div>
                <div className={s.howItem}>
                    <span className={s.icon}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5" fill="none">
                            <circle cx="2.5" cy="2.5" r="2.5" fill="#0E62F4" />
                        </svg>
                    </span>
                    <div className={s.howItemTitle}>
                        Preview an example message generated from your instruction
                    </div>
                    <div className={s.howItemContent}>
                        Click <b>“View example”</b> to see how your greeting will look with sample patient info.
                    </div>
                </div>
                <div className={s.howItem}>
                    <span className={s.icon}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5" fill="none">
                            <circle cx="2.5" cy="2.5" r="2.5" fill="#0E62F4" />
                        </svg>
                    </span>
                    <div className={s.howItemTitle}>
                        Save your instruction
                    </div>
                    <div className={s.howItemContent}>
                        Once you’re happy, save your greetings. We’ll send them automatically to every new patient after they book.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Tips;
